exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-role-and-branch\n{\n\tmargin-top: 50px;\n}\n\ntable.table-bordered{\n\t\tborder:1px solid transparent;\n\t\tmargin-top:20px;\n\t}\n/*table.table-bordered > thead > tr > th{\n\t\tborder:1px solid blue;\n}*/\ntable.table-bordered > tbody > tr > td{\n\t\tborder:1px solid transparent;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = main